import Box from 'v2/components/UI/Box';
import * as SC from './styles';
import { COLOR_DEFAULT, COLOR_ERROR, IInput } from './types';
import Text from 'v2/components/UI/Text';

const InputText = ({
  disabled,
  placeholder,
  type,
  value,
  width,
  maxWidth,
  errorMessage,
  name,
  label,
  colorLabel = COLOR_DEFAULT,
  onChange,
}: IInput) => {
  const renderErrorMessage = () => {
    if (errorMessage) {
      return (
        <Box>
          <Text color={COLOR_ERROR} fontSize={12} fontWeight={700}>
            {errorMessage}
          </Text>
        </Box>
      );
    }
  };
  const renderLabel = () => {
    if (label) {
      return (
        <Box>
          <Text color={colorLabel} fontWeight={500}>
            {label}
          </Text>
        </Box>
      );
    }
  };

  return (
    <Box
      flexDirection="column"
      gap={2}
      width={width ?? '100%'}
      maxWidth={maxWidth ?? '100%'}
    >
      {renderLabel()}
      <SC.Input
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        type={type}
        error={!!errorMessage}
        name={name}
        onChange={onChange}
      />

      {renderErrorMessage()}
    </Box>
  );
};

export default InputText;
